import React from "react";
import { TimelineZoom, type ZoomLevel } from "@/components/atoms/TimelineZoom";
import type { TimelineCustomRange } from "../../utils/chart/timeline-range.utils";

interface MobileTimelineControlsProps {
  zoomLevel: ZoomLevel;
  onZoomChange: (level: ZoomLevel) => void;
  customRange?: TimelineCustomRange | null;
  onCustomRangeChange?: (range: TimelineCustomRange) => void;
  onPanLeft: () => void;
  onPanRight: () => void;
  onGoToToday: () => void;
  onGoToStart?: () => void;
  onGoToEnd?: () => void;
}

export const MobileTimelineControls: React.FC<MobileTimelineControlsProps> = (
  props,
) => {
  return (
    <div className="lg:hidden border-b border-white/[0.08] bg-surface-secondary/80 px-3 py-2">
      <TimelineZoom {...props} className="w-full justify-center" />
    </div>
  );
};
